import React from 'react';
import { Box, Flex, Heading } from 'rebass';
import Frame from 'components/Frame';
import SignUpRoleDescription from 'modules/SignUp/components/SignUpRoleDescription';
import styled from 'styled-components';
import { SignUpRoleDescriptionContent } from 'modules/SignUp/content';
import { RECRUITER, EMPLOYER } from 'constants/index';
import usePageMeta from '../hooks/usePageMeta';

const { recruiter, employer } = SignUpRoleDescriptionContent;

const Content = styled(Flex)`
  @media screen and (max-width: 1024px) {
    flex-direction: column;
  }
`;

const SignUpRoleChoice: React.FC = (): JSX.Element => {
  usePageMeta({
    title: 'Register — BoostHiring',
    description:
      'Join BoostHiring as an employer or recruiter. Employers post jobs for free. Recruiters earn fees for successful placements.',
    canonical: 'https://boosthiring.ca/register',
  });

  return (
    <>
      <Box>
        <Frame>
          <Flex width="100%" flexDirection="column" py={7}>
            <Heading as="h2" textAlign="center" fontSize="36px" fontWeight={5} mb={7}>
              Transform the way you work
            </Heading>
            <Content justifyContent="space-between">
              <SignUpRoleDescription
                userRole={RECRUITER}
                userRoleTitle={recruiter.title}
                userRoleInfo={recruiter.info}
              />
              <SignUpRoleDescription
                userRole={EMPLOYER}
                userRoleTitle={employer.title}
                userRoleInfo={employer.info}
              />
            </Content>
          </Flex>
        </Frame>
      </Box>
    </>
  );
};

export default SignUpRoleChoice;
